import { createGetEnvVar } from '@hopin-team/dashboard-constants';
import {
  format,
  formatISO,
  parseISO,
  subDays,
  subMonths,
  subYears,
} from 'date-fns';

export const formatDuration = (duration: number) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  const hourText = hours > 0 ? `${hours}:` : '';
  const minutesText = minutes < 10 ? `0${minutes}` : minutes;
  const secondsText = seconds < 10 ? `0${seconds}` : seconds;

  return `${hourText}${minutesText}:${secondsText}`;
};

export const getDateWeekAgo = () => {
  return formatISO(subDays(new Date(), 7));
};

export const getDateMonthAgo = () => {
  return formatISO(subMonths(new Date(), 1));
};

export const getDateYearAgo = () => {
  return formatISO(subYears(new Date(), 1));
};

export const formatDateToReadable = (isoDateString: string) => {
  const date = parseISO(isoDateString);
  return format(date, "MMMM d, yyyy 'at' h:mm a");
};

export const generateSHA256Checksum = async (file: File): Promise<string> => {
  const buffer = await file.arrayBuffer();
  const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};

export const getContentHubMediaHost = createGetEnvVar(
  {
    local: 'https://d1k341uljhl4rl.cloudfront.net',
    staging: 'https://content-assets-stg.imgix.net',
    review: 'https://content-assets-stg.imgix.net',
    production: 'https://content-hub-assets.imgix.net',
  },
  'content-hub-media-host',
);

/**
 * Merges organization speakers with event speakers, giving precedence to org speakers.
 */
export const mergeSpeakers = <T extends { eventSpeakerId: string | null }>(
  orgSpeakers: T[],
  eventSpeakers: T[],
): T[] => {
  eventSpeakers.forEach(eventSpeaker => {
    if (eventSpeaker.eventSpeakerId) {
      const exists = orgSpeakers.some(
        speaker => speaker.eventSpeakerId === eventSpeaker.eventSpeakerId,
      );
      if (!exists) {
        orgSpeakers.push(eventSpeaker);
      }
    } else {
      orgSpeakers.push(eventSpeaker);
    }
  });

  return orgSpeakers;
};
